export function newSaleRequestGalles() {
return [   //2024 Release 2025-11-15 17:45:53
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Listing Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 197.16,
   left: 96.48,
   width: 400.92,
   height: 11.236
}
,
{
   page: 0,
   name: "MLS", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 197.16,
   left: 523.44,
   width: 63.24,
   height: 11.236
}
,
{
   page: 0,
   name: "List Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.52,
   left: 77.52,
   width: 98.04,
   height: 11.236
}
,
{
   page: 0,
   name: "Sale Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.52,
   left: 234.48,
   width: 109.80,
   height: 11.236
}
,
{
   page: 0,
   name: "Title CompanyCloser", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.52,
   left: 447.84,
   width: 137.40,
   height: 11.236
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 240.12,
   left: 92.64,
   width: 86.52,
   height: 11.236
}
,
{
   page: 0,
   name: "Date contract signed", 
   fontSize: 9,
   type: "date",
   top: 236.292,
   left: 293.892,
   width: 86.509,
   height: 15.454
}
,
{
   page: 0,
   name: "Date Scheduled Closing Date", 
   fontSize: 9,
   type: "date",
   top: 240.12,
   left: 503.28,
   width: 79.80,
   height: 11.236
}
,
{
   page: 0,
   name: "Earnest Money Amount", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 261.48,
   left: 144.72,
   width: 83.40,
   height: 11.236
}
,
{
   page: 0,
   name: "Date Due", 
   fontSize: 9,
   type: "date",
   top: 261.48,
   left: 288.48,
   width: 81.96,
   height: 11.236
}
,
{
   page: 0,
   name: "Listing Broker 1Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 304.2,
   left: 99.8398,
   width: 155.5202,
   height: 11.236
}
,
{
   page: 0,
   name: "Listing Broker 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 304.855,
   left: 301.178,
   width: 159.982,
   height: 11.236
}
,
{
   page: 0,
   name: "Commission", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 304.2,
   left: 534.96,
   width: 51.00,
   height: 11.236
}
,
{
   page: 0,
   name: "Buyer Broker 1Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 325.2,
   left: 99.8398,
   width: 155.5202,
   height: 13.2
}
,
{
   page: 0,
   name: "Buyer Broker 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 325.2,
   left: 301.178,
   width: 159.982,
   height: 12.545
}
,
{
   page: 0,
   name: "Commission_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 325.2,
   left: 535.44,
   width: 50.52,
   height: 11.236
}
,
{
   page: 0,
   name: "Referral Due To If Applicable", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 346.44,
   left: 160.32,
   width: 302.52,
   height: 11.236
}
,
{
   page: 0,
   name: "Amount", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 346.44,
   left: 514.08,
   width: 73.32,
   height: 11.236
}
,
{
   page: 0,
   name: "Seller Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 430.92,
   left: 94.08,
   width: 240.72,
   height: 11.236
}
,
{
   page: 0,
   name: "CompanyEntity", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 430.92,
   left: 407.04,
   width: 180.60,
   height: 11.236
}
,
{
   page: 0,
   name: "Seller Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 452.28,
   left: 92.4,
   width: 330.96,
   height: 11.236
}
,
{
   page: 0,
   name: "Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 452.28,
   left: 456.0,
   width: 131.64,
   height: 11.236
}
,
{
   page: 0,
   name: "Seller Email 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 473.64,
   left: 86.64,
   width: 232.56,
   height: 11.236
}
,
{
   page: 0,
   name: "Seller Email 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 473.64,
   left: 383.04,
   width: 202.92,
   height: 11.236
}
,
{
   page: 0,
   name: "Source Of Seller If Galles Client", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.0,
   left: 171.12,
   width: 416.76,
   height: 11.236
}
,
{
   page: 0,
   name: "Buyer Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 537.48,
   left: 94.56,
   width: 241.68,
   height: 11.236
}
,
{
   page: 0,
   name: "CompanyEntity_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 537.48,
   left: 404.4,
   width: 182.28,
   height: 11.236
}
,
{
   page: 0,
   name: "Buyer Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.08,
   left: 93.12,
   width: 331.68,
   height: 11.236
}
,
{
   page: 0,
   name: "Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.08,
   left: 457.44,
   width: 131.16,
   height: 11.236
}
,
{
   page: 0,
   name: "Buyer Email 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 580.44,
   left: 87.12,
   width: 233.40,
   height: 11.236
}
,
{
   page: 0,
   name: "Buyer Email 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 580.44,
   left: 384.96,
   width: 203.64,
   height: 11.236
}
,
{
   page: 0,
   name: "Source Of Buyer If Galles Client", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 601.8,
   left: 172.56,
   width: 416.52,
   height: 11.236
}
,
{
   page: 0,
   name: "AdditionalInfo", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 661.748,
   left: 28.1456,
   width: 563.0204,
   height: 118.219
}
] }
